import { actions, endpoints } from '../../../utils/constants'
import { Notification } from '../../components/index'
import { put, all, takeLatest, call } from 'redux-saga/effects'
import { Get } from '../../../utils/functions'
import { getHeader } from '../admin/admin.saga';

function* getRank() {
  try {
    const header = yield getHeader();
    const { data } = yield call(Get, `${endpoints.rank}`, header)
    yield put({ type: actions.FETCH_RANK_FINISH, payload: data })
  } catch (error) {
    yield Notification('error', 'Erro ao buscar rank!', error.message)
    yield put({ type: actions.FETCH_RANK_FAILURE })
  } 
}

export default function* FetchRank() {
  yield all([
    yield takeLatest(actions.FETCH_RANK_START, getRank)
  ])
}


// WEBPACK FOOTER //
// ./src/App/containers/ranking/ranking.saga.js